import {FormModalHOC, modalOptions} from '../../components/modals/FormModal';
import {buildUpdateRequestModal} from '../../config/redux-list/requestModals';
import {ProjectForm} from '../components/ProjectForm';
import {PROJECT_COLLECTION} from '../domain/config';
import {getUpdateProject} from '../reducers/state';
import {logger} from './logger';
import {UPDATE_PROJECT_PREFIX} from './state';


const EditProjectModal = FormModalHOC(ProjectForm, {
  modalHeaderLabel: 'projects.edit.header.label',
}, {
  showIsPrivate: true,
  canEditIsPrivate: false,
  showLocationOrientation: false,
  showOverrideCameraSettings: true,
  showCameraResolution: true,
  showJpgQuality: true,
  showVidQuality: false,
});

export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateProjectRequestModal,
} = buildUpdateRequestModal({
  prefix: UPDATE_PROJECT_PREFIX,
  getState: getUpdateProject,
  path: PROJECT_COLLECTION,
  modalOptions,
  modalComponent: EditProjectModal,
  logger,
});



// WEBPACK FOOTER //
// ./src/js/projects/redux/updateProject.js